import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-pencil-input',
  templateUrl: './pencil-input.component.html',
  styleUrls: ['./pencil-input.component.scss']
})
export class PencilInputComponent implements OnInit {
  @Input() public name: string;

  @Input() public input: string;
  @Output() public inputChange = new EventEmitter<string>();

  @Output() public submit = new EventEmitter<void>();

  @Input() public disabled = false;

  public showInput = false;

  constructor() {}

  public ngOnInit(): void {}

  public close() {
    this.showInput = false;
    this.submit.emit();
  }
}
